import ArrayHelper from './ArrayHelper.js';
import ObjectHelper from './ObjectHelper.js';

export default class DataHelper {
  static get types() {
    return {
      'null': '[object Null]',
      'object': '[object Object]',
      'array': '[object Array]',
      'string': '[object String]',
      'boolean': '[object Boolean]',
      'number': '[object Number]',
      'date': '[object Date]',
    };
  }

  static getType(prop) {
    return Object.prototype.toString.call(prop);
  }

  static cloneData(data) {
    return JSON.parse(JSON.stringify(data));
  }

  static isEmpty(value) {
    return [undefined, '', null, '0-0'].indexOf(value) !== -1 || ArrayHelper.isEmpty(value) || ObjectHelper.isEmpty(value);
  }

  static filterDeeply(data) {
    Object.keys(data).forEach(k => {
      if ([this.types.object, this.types.array].includes(this.getType(data[k]))) {
        this.filterDeeply(data[k]);
      }

      if (this.isEmpty(data[k])) {
        delete data[k];
      }
    });
    return data;
  }
}
